let DomUtils = {};
const Logger = require('./logger_utils');

/**
 * Waits for an element to appear on the DomUtils
 * @param {String} typeOfElem e.g. id
 * @param {String} elementName e.g. 'test'
 * @param {Function} callback
 * @param {Boolean} callback.success
 * @param {Element|String} callback.element Element on success, String on error
 * @param {Object} [options]
 * @param {Number} [options.timeout=10000] the timeout
 */
DomUtils.waitForElement = function(typeOfElem, elementName, callback, options) {
    options = options || {};
    var checkInterval = false,
        timeoutTimer = false;

    var onResponse = function(success, element) {
        if (checkInterval) clearInterval(checkInterval);
        if (timeoutTimer) clearTimeout(timeoutTimer);
        checkInterval = false;
        timeoutTimer = false;
        callback(success, element);
    };

    var getElement = function() {
        switch (typeOfElem) {
            case 'class':
                return document.getElementsByClassName(elementName)[0];
            case 'id':
                return document.getElementById(elementName);
            default:
                onResponse(false, 'Type of element not implemented. Type given: ' + typeOfElem);
        }
    };

    timeoutTimer = setTimeout(function() {
        onResponse(false, 'Timeout for element waiter.');
    }, options.timeout || 10000);

    var element = getElement();
    if (element) onResponse(true, element);
    else {
        checkInterval = setInterval(() => {
            element = getElement();
            if (element) {
                onResponse(true, element);
            }
        }, 50);
    }
};

/**
 * Creates a Element object based on a string representing HTML markup
 * @param {String} domString String containing a representation of the HTML markup to create as Element
 * @return {Object} A Javascript Element object containing the DOM obtained in domString
 */
DomUtils.createElementFromString = function(domString) {
    var element = document.createElement('div');
    element.innerHTML = domString;
    return element.firstChild;
};

/**
 * Creates an element based on input
 * @param {String} elementType the type of the DomUtils element to create, e.g. 'div'
 * @param {Object} [options={}]
 * @param {Object} [options.attributes={}] the attributes to apply on the element. e.g. { class: "player" }
 * @param {String} [options.innerHtml=""] the html of this element
 */

DomUtils.createElement = function(elementType, options) {
    var element = document.createElement(elementType);
    options = options || {};
    if (options.attributes) {
        for (var attr in options.attributes) {
            if (options.attributes.hasOwnProperty(attr)) {
                element.setAttribute(attr, options.attributes[attr]);
            }
        }
    }

    if (options.innerHtml) {
        element.innerHTML = options.innerHtml;
    }
    return element;
};

DomUtils.destroyElementByType = function(type, identifier) {

    if (!type) return false;
    let elem;

    if (type && type === 'id') {
        elem = document.getElementById(identifier);
    } else if (type && type === 'class') {
        const elems = document.getElementsByClassName(identifier);
        if (elems.length > 0) {
            elem = elems[0];
        }
    } else {
        Logger.debug('Could not find element for type: ' + type);
        return false;
    }
    if (!elem) return false;

    DomUtils.destroyElement(elem);
};

DomUtils.destroyElement = function(element) {
    if (element) {
        element.parentNode.removeChild(element);
        element = undefined;
    }
};

DomUtils.removeChildrenOfElement = function(element) {
    for (let i = 0; i < element.length; i++) {
        element[i].parentNode.removeChild(element[i]);
    }
    element.innerHTML = '';
};

DomUtils.removeAllParentClass = function(elements, className) {
    for (var $i = 0; $i < elements.length; $i++) {
        elements[$i].parentNode.classList.remove(className);
    }
};

DomUtils.removeAllClass = function(elements, className) {
    for (var $i = 0; $i < elements.length; $i++) {
        elements[$i].classList.remove(className);
    }
};

DomUtils.wrap = (target, wrapper = document.createElement('div')) => {
    ;[ ...target.childNodes ].forEach(child => wrapper.appendChild(child));
    target.appendChild(wrapper);
    return wrapper;
}

module.exports = DomUtils;



// WEBPACK FOOTER //
// ./src/util/dom_utils.js